// Adds an ISO 8601 duration (e.g., "P7D", "P1M", "P1Y") to a given date and returns a formatted string
// Example usage: addDurationToDate(new Date(), "P7D")
export function addDurationToDate(startDate: Date, isoDuration: string): string {
  // Regex to parse ISO 8601 durations
  const regex = /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?$/;
  const match = isoDuration.match(regex);
  if (!match) return '';

  const years = parseInt(match[1] || '0', 10);
  const months = parseInt(match[2] || '0', 10);
  const days = parseInt(match[3] || '0', 10);

  // Clone the date
  const result = new Date(startDate);
  result.setFullYear(result.getFullYear() + years);
  result.setMonth(result.getMonth() + months);
  result.setDate(result.getDate() + days);

  // Format as "28 October, 2025"
  return result.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
